export default __webpack_public_path__ + "static/media/qr_vehicle_poster.7c1f8826.png";